import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { App } from '@df/core/app';
import { Resource } from '@df/catalog/resource';
import { Customform } from '@df/catalog/customform/customform';

declare module '@df/catalog/resource' {
    interface IResources {
        customform: Resource<Customform, number>;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomformResource extends Resource<Customform, number> {
    static override instance = Customform;
    readonly invalidatesUniversal = false;
    readonly invalidatesPrerender = false;
}
